import {SET_NOTIFICATIONS} from './actionTypes';

export const setNotifications = (notifications) => {
  return {
    type: SET_NOTIFICATIONS,
    payload: notifications,
  };
};
